import http from "../../../../http-common";

const get = (data) => http.post("/NewVersion/GetNewVersionData", data);
export default { get };